import cloneDeep from "lodash.clonedeep";
import sortBy from "lodash.sortby";
import { CREATE_JOB_FAILURE,
  CREATE_JOB_REQUESTED,
  CREATE_JOB_SUCCESS,
  FETCH_JOBS_FAILURE,
  FETCH_JOBS_REQUESTED,
  FETCH_JOBS_SUCCESS,
  FETCH_JOB_BY_ID_SUCCESS,
  FETCH_JOB_BY_ID_REQUESTED,
  FETCH_JOB_BY_ID_FAILURE,
  UPDATE_JOB_FAILURE,
  UPDATE_JOB_REQUESTED,
  UPDATE_JOB_SUCCESS } from "../actions/jobs-actions-types";
import formatDate from "../pages/dashboard/common/commonFunctions.jsx";

const initialState = {
  addJobStatus: "pending",
  jobs: [],
  fetchJobsStatus: "pending",
  fetchJobByIdStatus: "pending",
  updateJobStatus: "pending",
};

export default function Jobs(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case CREATE_JOB_FAILURE:
      return {
        ...state,
        addJobStatus: "failed",
      };

    case CREATE_JOB_SUCCESS:
      return {
        ...state,
        addJobStatus: "success",
      };
    case CREATE_JOB_REQUESTED:
      return {
        ...state,
        addJobStatus: "request",
      };
    case FETCH_JOBS_FAILURE:
      return {
        ...state,
        fetchJobsStatus: "failed",
      };

    case FETCH_JOBS_SUCCESS:
      return {
        ...state,
        fetchJobsStatus: "success",
        jobs: payload,
        requestedCount: payload?.filter(
          (item) => item.status === "Requested",
        ).length || 0,
        quotedCount: payload?.filter(
          (item) => item.status === "Quoted",
        ).length || 0,
        acceptedCount: payload?.filter(
          (item) => item.status === "Accepted",
        ).length || 0,
        declinedCount: payload?.filter(
          (item) => item.status === "Declined",
        ).length || 0,
      };
    case FETCH_JOBS_REQUESTED:
      return {
        ...state,
        fetchJobsStatus: "request",
      };
    case FETCH_JOB_BY_ID_FAILURE:
      return {
        ...state,
        fetchJobByIdStatus: "failed",
      };

    case FETCH_JOB_BY_ID_SUCCESS:
      return {
        ...state,
        fetchJobByIdStatus: "success",
        jobs: sortBy(([...state.jobs, payload]), (job) => formatDate(job.deliveryDate, "dd-MM-yyyy")),
      };
    case FETCH_JOB_BY_ID_REQUESTED:
      return {
        ...state,
        fetchJobByIdStatus: "request",
      };
    case UPDATE_JOB_FAILURE:
      return {
        ...state,
        updateJobStatus: "failed",
      };
    case UPDATE_JOB_SUCCESS:
    { const jobList = cloneDeep(state.jobs);
      const index = jobList.findIndex((job) => job.identifier === payload.identifier);

      if (index > -1) {
        jobList[index] = payload;
      }

      return {
        ...state,
        updateJobStatus: "success",
        jobs: jobList,
      }; }
    case UPDATE_JOB_REQUESTED:
      return {
        ...state,
        updateJobStatus: "requested",
      };
    default:
      return state;
  }
}
